import { Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollToTopButton = ({ show, onClick }) => {
  if (!show) return null;

  return (
    <Fab
      color="primary"
      size="large"
      onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 32,
        right: 32,
        zIndex: 1000,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        "&:hover": {
          backgroundColor: "primary.dark",
        },
      }}
      aria-label="scroll to top"
    >
      <KeyboardArrowUpIcon sx={{ fontSize: 30 }} />
    </Fab>
  );
};

export default ScrollToTopButton;
